<template>
<div class="no-scroll-content" >
    <!-- <vx-card class="no-scroll-content" title="List of Filed Overtimes" > -->
        <!-- <vs-input class='hidden' v-model="employeeOvertime" /> -->
        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <!-- <vs-button type="gradient" @click="promptAddNewOvertime()" icon-pack="feather" icon="icon-file">Apply Overtime</vs-button> -->
        <vs-table stripe max-items="7" pagination v-model="selected"  search  :data="getEmployeeOvertimeRequests">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <vs-th sort-key="oTDate">Date</vs-th>
                <vs-th>From Time</vs-th>
                <vs-th>To Time</vs-th>
                <vs-th>No Of Hours</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Employee</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].otDate">
                        {{data[indextr].otDate | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].fromTime">
                        {{data[indextr].fromTime | time}}
                    </vs-td>
                    <vs-td :data="data[indextr].toTime">
                        {{data[indextr].toTime | time }}
                    </vs-td>
                    <vs-td :data="data[indextr].noOfHours">
                        {{data[indextr].noOfHours}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td :data="data[indextr].user.photoUrl">
                        <vx-tooltip v-bind:text="data[indextr].user.fullName">
                             <vs-avatar v-if="data[indextr].user.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                            <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="data[indextr].user.fullName" :color="data[indextr].user.fullName.length < 12 ? 'success' : data[indextr].user.fullName.length <= 15 ? 'primary' : data[indextr].user.fullName.length <= 20 ? 'warning' : 'danger'"/>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td  :data="data[indextr].fileId" >
                            <vs-icon v-show="data[indextr].fileId != [] && data[indextr].fileId != null" @click="downloadFile(data[indextr].fileId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                    </vs-td>
                     <vs-td :data="data[indextr].fileId">
                                <span class="flex items-center px-2 py-1 rounded">
                                    <div  :class="onGetStatus(data[indextr]) == 'Approved' ? 'h-3 w-3 rounded-full mr-2 bg-success' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'h-3 w-3 rounded-full mr-2 bg-partial' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                                        onGetStatus(data[indextr]) == 'Denied' ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'h-3 w-3 rounded-full mr-2 bg-draft' :
                                        onGetStatus(data[indextr]) == 'For Approval' ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 'h-3 w-3 rounded-full mr-2 bg-danger'"/>
                                        {{onGetStatus(data[indextr])}}
                                    
                                </span>
                        </vs-td>
                        <vs-td >
                            <!-- <span :data="item" :key="index" v-for="(item, index) in data[indextr].approversOTs"> -->
                            <span>
                                {{ data[indextr].remarks}}
                            </span>
                        </vs-td>
                        <vs-td >
                            <div class="vx-row">
                                <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr])) ? 'Approve' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="CheckIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onApproved(data[indextr].employeeFiledOvertimeId)" />
                                    </vx-tooltip>
                                </div>
                                <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr])) ? 'Deny' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onDenied(data[indextr].employeeFiledOvertimeId)" />
                                    </vx-tooltip>
                                </div>
                                 <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr]))? 'Ask to Revise' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onForRevision(data[indextr].employeeFiledOvertimeId)" />
                                    </vx-tooltip>
                                </div>
                            </div>
                        </vs-td>
                </vs-tr>
            </template>
        </vs-table>


    
    <!-- </vx-card> -->
</div>  
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            selected: [],
            employeeFiledOvertimeId: null,

            remarks: '',
            datenow: new Date(),

            activeDeniedDialog: false,
            activeRevisionDialog: false,
        }
    },
    created() {

         const payload = {
                    sortBy: 'OTDate',
                    sortOrder: 'Desc',
                    pageNumber: 1,
                    pageSize: -1,
                    isApprover: true
                }
                this.$store.dispatch('overtime/getAllEmployeeOvertime', payload)
    },
    
    computed: {
        getEmployeeOvertimeRequests () {
            return this.$store.state.overtime.employeeFiledOvertime 
        },
        onGetStatus() {
             return (data) => {
                var overtimeStatus = ''
                var c = data.approversOTs.length
                data.approversOTs.forEach((a) => {
                    if(a.isApproved && a.priorityId == 1){
                        if(c > 1) {
                            overtimeStatus = 'Partially Approved'
                        }
                        else
                            overtimeStatus = 'Approved'
                    } 
                    else if(a.isApproved && a.priorityId == 2){
                        if(c > 2) {
                            overtimeStatus = 'Partially Approved'
                        }
                        else
                            overtimeStatus = 'Approved'
                    }else if (data.isCancelled) {
                        overtimeStatus = 'Cancelled'
                    } else if(a.isRevised) { 
                        overtimeStatus = 'For Revision'      
                    }else if(a.isDenied) { 
                        overtimeStatus = 'Denied'
                    }else if(data.isRetracted) { 
                        overtimeStatus = 'Retracted'
                    }else if (data.isDraft) {
                        overtimeStatus = 'Draft'
                    }else if (data.isSubmitted && overtimeStatus == '') {
                        overtimeStatus = 'For Approval'
                    }
                    
                    // if(a.approverId == this.$store.state.AppActiveUser.uid)
                    // this.priorityId = a.priorityId
                })
                return overtimeStatus
             }
        },
         onCheckPriority() {
            return (approvers, status) => {
                var s = false
                var priorityId = 0
                approvers.approversOTs.forEach(a => {
                    if(a.approverId == this.$store.state.AppActiveUser.uid)
                        priorityId =  a.priorityId
                })
                
                switch(priorityId){
                    case 1:
                        if(status == 'For Approval')
                            s = true
                        else
                            s = false
                        break;
                    case 2:
                    case 3:
                        if(status == 'Partially Approved')
                            s = true
                        else
                            s = false
                        break;
                }
                console.log(priorityId)
                console.log(s)
                return s
      
            }
            
             
        },
        getCurrentDate() {
            return moment(new Date()).utc().format("YYYY-MM-DD")
        },
        approverName() {
            return  this.$store.getters['overtime/approverName'](this.$store.state.AppActiveUser.uid) 
        },
      
        validRemarks(){
            return (this.remarks.length > 0)
        }
    },
    methods: {
        onApproved(filedOvertimeId) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Approve'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                const data = { 
                    employeeFiledOvertimeId: filedOvertimeId,
                    action:  "APPROVED", 
                    isUnread : false, 
                    isApproved:  true, 
                    approvedOn : this.getCurrentDate, 
                    isRetracted : false, 
                    approverId: this.$store.state.AppActiveUser.uid 
                    }
                this.$store.dispatch('overtime/onApproved', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully approved overtime request.", "Approved Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })
                 } else
                        this.$alert("", 'Cancelled', "info")
            })


        },
        onDenied(filedOvertimeId) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "Note: You will not be able to revert this once you click the Deny button",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Deny',
              inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.remarks = result.value
                    const data = { 
                        employeeFiledOvertimeId: filedOvertimeId,
                        action: "DENIED", 
                        isUnread : false, 
                        isDenied: true, 
                        deniedOn : this.getCurrentDate, 
                        isRetracted : false, 
                        comments : this.remarks,
                        approverId: this.$store.state.AppActiveUser.uid
                    }
                    this.$store.dispatch('overtime/onDenied', data)
                    .then((response) => { 
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully denied overtime request.", "Denied Successfully", "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                        })
                } else
                    this.$alert("", 'Cancelled', "info")
            }) 
            this.$vs.loading.close()


        },
        onForRevision(filedOvertimeId) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ask for revision?',
               inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.remarks = result.value
                const data = { 
                    employeeFiledOvertimeId: filedOvertimeId,
                    action: "REVISED", 
                    isUnread : false, 
                    isRevised: true, 
                    forRevisionOn : this.getCurrentDate, 
                    isRetracted : false, 
                    comments : this.remarks, 
                    approverId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('overtime/onRevised', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully asked for overtime request revision.", "Asking for Revision Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })
                } else
                    this.$alert("", 'Cancelled', "info")

            })
            this.$vs.loading.close()


        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
    }
    
}
</script>

